import PhotoPlaceholder from 'components/assets/nophoto.svg'
export const resizeGdbImage = (
  url: string,
  width: number,
  height?: number,
  options?: object
) => {
  if (!url || !url.startsWith('https://gdb.')) {
    if (url.startsWith('https')) {
      return url
    } else {
      return PhotoPlaceholder
    }
  }

  const optionsQuery = options
    ? Object.entries(options)
        .map(([key, value]) => `${key}${encodeURIComponent(value)}`)
        .join('')
    : ''

  return url.replace(
    /(\.[a-zA-Z]+)$/,
    `_w${width}${height ? `_h${height}` : ''}${optionsQuery}$1`
  )
}
